import { FormikBag, FormikProps } from 'formik';

import { Address } from 'common/api/models/Address';
import { toApiError } from './api';
import * as Yup from 'yup';

export function mergeFields<T>(fields: T, merge: any): T {
  for (let k in merge) {
    if (merge.hasOwnProperty(k) && fields.hasOwnProperty(k) && merge[k] !== undefined && merge[k] !== null) {
      fields[k] = typeof merge[k] === 'boolean' ? (merge[k] ? '1' : '0') : merge[k];
    }
  }
  return fields;
}

export function mergeAddress(address?: Address, prefix?: string) {
  if (!address) {
    return {};
  }
  return {
    [prefix + '_street1']: address.street1,
    [prefix + '_street2']: address.street2,
    [prefix + '_city']: address.city,
    [prefix + '_state']: address.state,
    [prefix + '_country']: address.country,
    [prefix + '_postal']: address.postal,
  };
}

export function unprefixAddress(values: any, prefix: string) {
  return values[prefix + '_street1'] ||
    values[prefix + '_city'] ||
    values[prefix + '_state'] ||
    values[prefix + '_country'] ||
    values[prefix + '_postal']
    ? {
        street1: values[prefix + '_street1'],
        street2: values[prefix + '_street2'],
        city: values[prefix + '_city'],
        state: values[prefix + '_state'],
        country: values[prefix + '_country'],
        postal: values[prefix + '_postal'],
      }
    : undefined;
}

/**
 * Given an API error, make appropriate changes to a Formik form to register the errors
 * @param apiError api error response
 * @param bag bag of formik callbacks
 */
export function processApiError<P, V>(
  apiError: any,
  bag: Pick<FormikBag<P, V>, 'setStatus' | 'setErrors' | 'setSubmitting'>
) {
  bag.setSubmitting(false);
  if (apiError.response && apiError.response.data && apiError.response.data.errors) {
    let errors = {};
    for (let err of apiError.response.data.errors) {
      errors[err.field] = err.message;
    }
    bag.setErrors(errors);
  } else {
    bag.setStatus(toApiError(apiError));
  }
}

export function isFieldValid(form: FormikProps<any>, field: string) {
  return !(form.touched[field] && form.errors[field]);
}

export function toFormGroupStyle(field: string, props: FormikProps<any>) {
  if (!props.touched) {
    console.log('touched is empty');
    return undefined;
  }
  if (!isFieldValid(props, field)) {
    return 'danger';
  } else if (props.touched[field] && props.values[field] !== '') {
    return 'success';
  } else {
    return undefined;
  }
}

/**
 * Returns a object (not a full schema so you can spread it) of prefixed address validations
 *
 * @example
 *  <Formik
 *    validationSchema={Yup.object().shape({
 *     phone: Yup.object().string(),
 *     ...addressValidationSchemaFactory('work'),
 *     ...addressValidationSchemaFactory('billing')
 *     ...addressValidationSchemaFactory('shipping')
 *    })}
 *  />
 */
export const addressValidationSchemaFactory = (prefix: string, required: boolean = false) =>
  required
    ? {
        [prefix + '_street1']: Yup.string().required('Required'),
        [prefix + '_city']: Yup.string().required('Required'),
        [prefix + '_state']: Yup.string().required('Required'),
        [prefix + '_country']: Yup.string()
          .required('Required')
          .matches(/^[A-Z]{2}$/, 'Invalid country'),
        [prefix + '_postal']: Yup.string().required('Required'),
      }
    : {
        [prefix + '_street1']: Yup.string(),
        [prefix + '_city']: Yup.string(),
        [prefix + '_state']: Yup.string(),
        [prefix + '_country']: Yup.string().when([prefix + '_state'], {
          is: (value: any) => !!value,
          then: Yup.string()
            .required('Required')
            .matches(/^[A-Z]{2}$/, 'Invalid country'),
        }),
        [prefix + '_postal']: Yup.string(),
      };



// WEBPACK FOOTER //
// ./src/common/utils/form.ts